module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/administrative/martyna-stanczyk-ccc7997588977cf3892587056e0e416d.webp";